<div class="selector-container grid small grid-three d-sm-none">
    <app-selector
      *ngFor="let entry of dataEntries | excludeFilter:excludeSystem"
      [checkbox]="true"
      [id]="entry.ID"
      [name]="entry.Description+'_B2C' | translate"
      [description]="entry.MainDescription+'_B2C' | translate"
      [showDescription]="true"
      [showNameUnderDescription]="true"
      [tooltip]="entry.tooltip"
      [tooltipType]="tooltipType"
      [imageClassFromFrontEnd]="entry.imageClassFromFrontEnd"
      [checked]="entry.checked"
      [disabled]="defaultSystems.indexOf(entry.Code) !== -1"
      [isSingleItem]="false"
      [showInfo]="!!entry.videoUrl"
      (selected)="onSelectorClicked($event)"
      (infoClicked)="onInfoClick($event)"
    ></app-selector>
</div>

<!-- start: mobile sectiona -->
<div class="selector-container grid small grid-three d-lg-none" style="display: none;">
  <app-selector
    *ngFor="let entry of dataEntries | includeFilter:includeSystemMobile"
    [checkbox]="true"
    [id]="entry.ID"
    [name]="entry.Description+'_B2C' | translate"
    [description]="entry.MainDescription+'_B2C' | translate"
    [showDescription]="true"
    [showNameUnderDescription]="true"
    [tooltip]="entry.tooltip"
    [tooltipType]="tooltipType"
    [imageClassFromFrontEnd]="entry.imageClassFromFrontEnd"
    [checked]="entry.checked"
    [disabled]="defaultSystems.indexOf(entry.Code) !== -1"
    [isSingleItem]="false"
    [showInfo]="!!entry.videoUrl"
    (selected)="onSelectorClicked($event)"
    (infoClicked)="onInfoClick($event)"
  ></app-selector>
</div>

<div class="selector-container grid small grid-three d-lg-none">
  <app-selector
    *ngFor="let entry of dataEntries | excludeFilter:excludeSystem"
    [checkbox]="true"
    [id]="entry.ID"
    [name]="entry.Description+'_B2C' | translate"
    [description]="entry.MainDescription+'_B2C' | translate"
    [showDescription]="true"
    [showNameUnderDescription]="true"
    [tooltip]="entry.tooltip"
    [tooltipType]="tooltipType"
    [imageClassFromFrontEnd]="entry.imageClassFromFrontEnd"
    [checked]="entry.checked"
    [disabled]="defaultSystems.indexOf(entry.Code) !== -1"
    [isSingleItem]="false"
    [showInfo]="!!entry.videoUrl"
    (selected)="onSelectorClicked($event)"
    (infoClicked)="onInfoClick($event)"
  ></app-selector>
</div>
<!-- end: mobile sectiona -->

<app-video-modal [(open)]="openVideoModal" [(url)]="videoModalUrl"></app-video-modal>
